/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { AbstractRestService, identity, RestSettings } from '@gh/core-data';
import { Observable } from 'rxjs';
import { FormulaCalculationDto, FormulaCalculationResultDto } from './formula.dto';
import { FormulaCalculationMapper } from './formula.mapper';

@Injectable()
export class FormulaRestService extends AbstractRestService {
  constructor(private settings: RestSettings) {
    super(settings);
  }

  calculate(request: FormulaCalculationDto): Observable<FormulaCalculationResultDto> {
    return this.httpPut(`${this.bp}/formula-calculation`, request, FormulaCalculationMapper, identity());
  }
}
